import React, { createContext, useContext, useEffect, useState } from "react";
import { adminAuthService } from "../services/authService";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

const ADMIN_RESET_EMAIL_KEY = "cynos_admin_reset_email";
const ADMIN_RESET_DELIVERY_KEY = "cynos_admin_reset_delivery_target";
const ADMIN_RESET_TOKEN_KEY = "cynos_admin_reset_token";
const ADMIN_PASSWORD_RESET_TOKEN_KEY = "cynos_admin_password_reset_token";

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("cynos_admin_token");
    if (!token) { setChecking(false); return; }
    adminAuthService.me()
      .then((data) => setAdmin(data))
      .catch(() => { localStorage.removeItem("cynos_admin_token"); setAdmin(null); })
      .finally(() => setChecking(false));
  }, []);

  const login = async (email, password) => {
    const data = await adminAuthService.login(email, password);
    localStorage.setItem("cynos_admin_token", data.access_token);
    setAdmin(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("cynos_admin_token");
    setAdmin(null);
  };

  const forgotPassword = async (email) => {
    const data = await adminAuthService.forgotPassword(email);
    localStorage.setItem(ADMIN_RESET_EMAIL_KEY, email);
    localStorage.removeItem(ADMIN_PASSWORD_RESET_TOKEN_KEY);
    if (data.reset_token) {
      localStorage.setItem(ADMIN_RESET_TOKEN_KEY, data.reset_token);
    }
    if (data.delivery_target) {
      localStorage.setItem(ADMIN_RESET_DELIVERY_KEY, data.delivery_target);
    }
    return data;
  };

  const verifyOtp = async (otp) => {
    const resetToken = localStorage.getItem(ADMIN_RESET_TOKEN_KEY);
    if (!resetToken) {
      throw new Error("Reset token is missing. Please request a new OTP.");
    }
    const data = await adminAuthService.verifyOtp(resetToken, otp);
    if (data.password_reset_token) {
      localStorage.setItem(ADMIN_PASSWORD_RESET_TOKEN_KEY, data.password_reset_token);
    }
    return data;
  };

  const resetPassword = async (newPassword) => {
    const passwordResetToken = localStorage.getItem(ADMIN_PASSWORD_RESET_TOKEN_KEY);
    if (!passwordResetToken) {
      throw new Error("Password reset token is missing. Please verify your OTP first.");
    }
    const data = await adminAuthService.resetPassword(passwordResetToken, newPassword);
    localStorage.removeItem(ADMIN_RESET_TOKEN_KEY);
    localStorage.removeItem(ADMIN_PASSWORD_RESET_TOKEN_KEY);
    localStorage.removeItem(ADMIN_RESET_DELIVERY_KEY);
    localStorage.removeItem(ADMIN_RESET_EMAIL_KEY);
    return data;
  };

  return (
    <AuthContext.Provider value={{ admin, checking, login, logout, forgotPassword, verifyOtp, resetPassword }}>
      {children}
    </AuthContext.Provider>
  );
};
